// Keep these limits aligned with the NCR API and its MySQL column capacities.
export const NCR_TEXT_LIMITS = {
  referenceClause: 10000,
  branchGroupDescription: 10000,
  personInCharge: 191,
  teamMember: 191,
  personInChargeSignature: 191,
  headOfQualitySignature: 191,
  kpiReferenceCode: 191,
  nonConformityDescription: 10000,
  rootCause: 10000,
  correctiveAction: 10000,
  remarks: 10000,
};

export function ncrTextError(field, value) {
  const limit = NCR_TEXT_LIMITS[field];
  if (value == null || !limit) return "";
  if (typeof value !== "string") return "Enter text only.";
  const count = Array.from(value).length;
  return count > limit ? `Maximum ${limit} characters (${count} entered).` : "";
}

export function hasNcrTextErrors(values) {
  return Object.keys(NCR_TEXT_LIMITS).some((field) =>
    ncrTextError(field, values?.[field]),
  );
}

export function ncrRepetitionError(value) {
  if (value == null || value === "") return "";
  const count = Number(value);
  return ["number", "string"].includes(typeof value) && String(value).trim() !== "" &&
    Number.isInteger(count) && count >= 0 && count <= 2147483647
    ? "" : "Enter a whole number from 0 to 2147483647.";
}

export function hasNcrHeaderErrors(values) {
  const date = values?.estimatedClosureDate;
  const invalidDate = date != null && (typeof date.isValid === "function"
    ? !date.isValid() : !Number.isFinite(new Date(date).getTime()));
  return hasNcrTextErrors(values) || ![1, 2].includes(Number(values?.statusId)) ||
    Boolean(ncrRepetitionError(values?.repetitionTime)) || invalidDate;
}

export function ncrTextFieldProps(field, value, helperText) {
  const message = ncrTextError(field, value);
  return {
    error: Boolean(message),
    helperText: message || helperText || "",
  };
}
